﻿window.timeinterval = function () {

    return {
        GetBeginPeriodSelection: function (selectedInterval, dateTimePicker) {

            if (selectedInterval == null || selectedInterval == undefined) {
                selectedInterval = timeIntervalEnum.LastDay;
            }

            if (dateTimePicker == null || dateTimePicker == undefined) {
                dateTimePicker = "StartSelection";
            }

            var beginDateTime = moment();

            switch (selectedInterval) {                
                case timeIntervalEnum.Day:
                    beginDateTime.subtract(1, 'days');
                    break;

                case timeIntervalEnum.Week:
                    beginDateTime.subtract(1, 'weeks');
                    break;

                case timeIntervalEnum.Month:
                    beginDateTime.subtract(1, 'months');
                    break;

                case timeIntervalEnum.Year:
                    beginDateTime.subtract(1, 'years');
                    break;

                case timeIntervalEnum.AskedPeriod:
                    var from = $("#" + dateTimePicker).data("kendoDateTimePicker");
                    return from.value();
            }

            return new Date(beginDateTime.unix() * 1000);
        },

        GetEndPeriodSelection: function (selectedInterval, dateTimePicker) {

            if (selectedInterval == null || selectedInterval == undefined) {
                selectedInterval = timeIntervalEnum.LastDay;
            }

            if (dateTimePicker == null || dateTimePicker == undefined) {
                dateTimePicker = "EndSelection";
            }

            var endDateTime = moment();

            switch (selectedInterval) {

                case timeIntervalEnum.NextMonth:
                    endDateTime.add(1, 'months');
                    break;

                case timeIntervalEnum.NextWeek:
                    endDateTime.add(7, 'days');
                    break;

                case timeIntervalEnum.AskedPeriod:
                    var to = $("#" + dateTimePicker).data("kendoDateTimePicker");
                    return to.value();
            }

            return new Date(endDateTime.unix() * 1000);
        }
    }
}();